import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { notificationItemEntityRequest } from "../../../../actions/notification-actions"
import { notificationTypes } from "../../../../config/application-definitions"
// import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines";

class NotificationEntityPreview extends Component {
    getSIUrlForEntity() {
        const { type, entityId } = this.props
        const baseUrl = process.env.REACT_APP_INTELLIGENCE_URI
        switch (type) {
            case "knowledge":
                return `${baseUrl}/monitor/latest-knowledge/${entityId}`
            case "cluster":
                return `${baseUrl}/monitor/emerging-themes/${entityId}`
            case "topic":
                return `${baseUrl}/topics/${entityId}`
            case "event":
                return `${baseUrl}/membership-events/${entityId}`
            default:
                return null
        }
    }

    render() {
        const { entityId, isEditing, type } = this.props

        const siUrl = this.getSIUrlForEntity()
        if (!entityId || !siUrl) {
            return null
        }
        const entityLabel =
            (notificationTypes[type] && notificationTypes[type].label) || "Item"

        return (
            <Fragment>
                {isEditing ? (
                    <p>
                        Please check the link to Strategic Intelligence to
                        ensure you have the right related {entityLabel} ID.
                    </p>
                ) : (
                    <p>
                        {entityLabel} ID: {entityId}
                    </p>
                )}
                <p>
                    <a href={siUrl} target="_blank" rel="noopener noreferrer">
                        {siUrl}
                    </a>
                </p>
            </Fragment>
        )
    }
}

const mapStateToProps = (state, { entityId, type }) => {
    let entityState = null
    if (type === "knowledge") {
        entityState = state.entities.knowledge
    } else if (["topic", "cluster"].includes(type)) {
        entityState = state.entities[type + "s"]
    }
    const entity = entityState ? entityState[entityId] : null
    return { entity }
}

const mapDispatchToProps = (dispatch, { type, entityId }) => {
    return {
        fetchEntity: () =>
            dispatch(notificationItemEntityRequest(entityId, type)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationEntityPreview)
